import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type StateProductCountEntry } from 'lib/stateProductCounts';
import { RootState } from 'lib/store';
import { DEFAULT_PLAN_YEAR } from 'lib/planYears';

export interface PlanYearAvailability {
  stateProductCounts: Record<string, StateProductCountEntry>;
  carrierCountsByState: Record<string, number>;
  medSuppEligibleStates: string[];
}

export interface AvailabilityState {
  byYear: Record<number, PlanYearAvailability>;
  selectedPlanYear: number;
}

const initialState: AvailabilityState = {
  byYear: {},
  selectedPlanYear: DEFAULT_PLAN_YEAR,
};

const availabilitySlice = createSlice({
  initialState,
  name: 'availability',
  reducers: {
    setSelectedPlanYear: (state, action: PayloadAction<number>) => {
      state.selectedPlanYear = action.payload;
    },
  },
});

const { reducer } = availabilitySlice;

export const { setSelectedPlanYear } = availabilitySlice.actions;

export const selectAvailabilityState = (state: RootState) => state.availability;

export default reducer;
